import * as React from 'react';
import { memo } from 'react';

import { getCachedPath } from 'helper/cache';
import appConfig from 'helper/mapBackendConfig';

export type IconProps = {
	modifier?: string;
	delegate?: string;
	iconName?: string;
};

export class Icon extends React.Component<IconProps> {
	public static displayName = 'Icon';
	public static defaultProps = {
		delegate: 'js-a-icon',
	};

	public render() {
		const rootUrl = appConfig.env.baseUrlUi;
		const { modifier, delegate, iconName } = this.props;

		if (!iconName) {
			return null;
		}

		const cachedPath = getCachedPath('icons.svg');
		const xlinkHref = `${rootUrl}/assets/svg/${cachedPath}#${iconName}`;

		const use = `<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${xlinkHref}" data-delegate="${delegate ||
			''}"></use>`;

		return (
			<svg
				className={`a-icon js-a-icon${modifier ? ` a-icon--${modifier}` : ''}`}
				xmlns="http://www.w3.org/2000/svg"
				role="img"
				dangerouslySetInnerHTML={{ __html: use }}
			/>
		);
	}
}

const baseUrlUi = appConfig.env.baseUrlUi;
const spritemapPath: string = getCachedPath('icons.svg');

/*
 * Create a string which contains the markup for an Icon,
 * used in i18n labels as placeholders (atm).
 * @param { string } name
 */
export const createStaticIcon = (name: string): string => {
	const iconNode = [
		`<svg class="a-icon" role="img">`,
		`<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${baseUrlUi}/assets/svg/${spritemapPath}#${name}" />`,
		`</svg>`,
	];

	return iconNode.join(' ');
};

export default memo(Icon, (prevProps, nextProps) => {
	return prevProps.modifier === nextProps.modifier && prevProps.iconName === nextProps.iconName;
});
